import app from '../app';
import constants from '../helpers/constants';
import _ from '../libs/lodash';
import teamModel from '../models/team'

let plans = {};

if (!app.config.mode.isBase) {
  plans = new webix.DataCollection();
} else {
  plans = new webix.DataCollection({
    url: `rest->/api/payment/?${new Date().getTime()}`,
  });
}

plans.getStatus = function () {
  if (user.team.activites > 0) {
    return user.team.activites;
  }

  if (user.subscription.activites > 0) {
    return user.subscription.activites;
  }

  if (user.subscription.activites < 0) {
    user.subscription.activites = 0;
  }

  return user.subscription.activites;
};

plans.isPaidTeam = function () {
  return _.includes([2, 4, 5, 6], user.subscription.activites);
};

plans.isTeam = function () {
  return user.subscription.activites > 0 && user.subscription.is_team === 1;
};

plans.isTrial = function () {
  return user.subscription.payment_plans_id === 12;
};

plans.isActiveTrial = function () {
  return user.subscription.activites === 12;
};

plans.isExpiredTrial = function () {
  return this.isTrial() && user.subscription.activites === 0 || ( this.isResourcesMoreThanPaid() && !plans.isExpired() );
};

plans.isResourcesMoreThanPaid = function(){ 
  return teamModel.getCountOfLeftInvitation() < 0 ;
}

plans.isExpired = function () {
  return user.subscription.activites < 1;
};

plans.isActiveAccount = function () {
  return plans.getStatus() > 0 && user.team.status !== 2;
}

plans.isActive = function () {
  return user.subscription.activites > 1;
}

plans.isActiveSubscription = function () {
  return user.subscription.activites > 1 && user.subscription.status_code !== 8;
},

plans.isOverSubscription = function () {
  return user.subscription.activites < 1 && !plans.isTrial();
}

plans.isActiveTeamAccount = function () {
  var isUserAccount = plans.getStatus() >= 3;

  return isUserAccount && user.team.status !== 2;
},

plans.suspend = function (callback) {
  return webix.ajax().post('/payment/plan/suspend')
    .then(response => {
      const data = response.json();

      callback(data);

      return webix.promise.resolve(data);
    })
    .fail(() => {
      callback();

      return webix.promise.resolve();
    });
};

plans.renew = function (callback) {
  webix.ajax().post('/payment/plan/renew')
    .then(response => {
      const data = response.json();

      callback(data);
    });
};

/**
 * Returns current subscription status object from PayPro
 * @return {Promise}
 */
plans.getSubscriptionStatus = function (provider) {
  return webix.ajax().get('/payment/plan/subscriptionsDetail', { provider })
    .then(data => data.json())
    .fail(error => ({}));
};

/**
 * Returns next available plan for upgrade
 */
plans.getNextPlan = function () {
  const subscription = user.subscription;
  const maxAvailableCountOfUsers = 100;

  if (subscription.payment_plans_id === constants.PLANS.GANTT_PRO) {
    if (subscription.user_count >= maxAvailableCountOfUsers) {
      return 101;
    }

    return subscription.user_count;
  }
  if (subscription.payment_plans_id === constants.PLANS.ESSENTIAL) {
    return 5;
  }
  if (subscription.payment_plans_id === constants.PLANS.TEAM_5) {
    return 10;
  }
  if (subscription.payment_plans_id === constants.PLANS.TEAM_10) {
    return 15;
  }

  return 0;
};

/**
 * Upgrade current subscription
 * Returns next available plan for upgrade
 * @return {Promise}
 */
plans.upgradePlan = function (upgradeData) {
  // const testPlan = {
  //   user_count: 5,
  //   billing_period: 1,
  //   is_annual: 0,
  //   planId: 15
  // };

  // upgradeData.nextPlan = testPlan;

  // console.log('upgradePlan-=-=>',upgradeData);

  return webix.ajax()
    .headers({ 'Content-type': 'application/json' })
    .post('/payment/plan/upgrade', upgradeData)
    .then(data => {
      const parsedData = data.json();

      return parsedData;
    });
};

plans.sendLoginEmailForChangePaymentMethod = function () {
  webix.ajax().post('payment/plan/sendOnetimeLoginEmail');
};

plans.hasCustomPlanToUpgrade = function () {
  return user.paymentProducts && user.paymentProducts.custom;
};

plans.getAffiliate = function () {
  if (user.affiliate && user.affiliate.percent && user.affiliate.coupon && user.affiliate.isStillValid) {
    return user.affiliate.percent;
  }

  return false;
};

app.on('app:start', () => {
  webix.promise.all([plans.waitData]).then(() => {
    app.trigger('plans:init');
  });
});

export default plans;
